/**
 * Keys for drawn rows that carry no id of their own (a message's buttons, a list's sections, a
 * preview's messages): the row's own content, with a count for a repeat ("Yes", "Yes 2"), so a
 * row keeps its key when another row is added or removed around it.
 */
export function withContentKeys<T>(
	items: readonly T[],
	contentOf: (item: T) => string,
): { key: string; item: T }[] {
	const seen = new Map<string, number>();
	return items.map((item) => {
		const content = contentOf(item);
		const count = (seen.get(content) ?? 0) + 1;
		seen.set(content, count);
		return { key: count === 1 ? content : `${content} ${count}`, item };
	});
}
